import { create } from 'zustand';
import { DialogState, ConfirmDialogOptions, AlertDialogOptions } from '../types/dialog';

interface DialogStore extends DialogState {
  showConfirmDialog: (options: ConfirmDialogOptions) => Promise<boolean>;
  showAlertDialog: (options: AlertDialogOptions) => Promise<void>;
  closeDialog: () => void;
  handleConfirm: () => void;
  handleCancel: () => void;
}

export const useDialogStore = create<DialogStore>((set, get) => ({
  isOpen: false,
  type: null,
  options: null,
  resolve: undefined,

  showConfirmDialog: (options: ConfirmDialogOptions) => {
    return new Promise<boolean>((resolve) => {
      set({
        isOpen: true,
        type: 'confirm',
        options: {
          confirmText: '确定',
          cancelText: '取消',
          confirmVariant: 'primary',
          ...options,
        },
        resolve,
      });
    });
  },

  showAlertDialog: (options: AlertDialogOptions) => {
    return new Promise<void>((resolve) => {
      set({
        isOpen: true,
        type: 'alert',
        options: {
          type: 'info',
          confirmText: '确定',
          ...options,
        },
        resolve: () => resolve(),
      });
    });
  },

  closeDialog: () => {
    set({
      isOpen: false,
      type: null,
      options: null,
      resolve: undefined,
    });
  },

  handleConfirm: () => {
    const { resolve, closeDialog } = get();
    if (resolve) {
      resolve(true);
    }
    closeDialog();
  },

  handleCancel: () => {
    const { resolve, closeDialog } = get();
    if (resolve) {
      resolve(false);
    }
    closeDialog();
  },
}));